import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectReceipt } from "../../redux/slices/receiptSlice";
import { selectRegistrationAccount } from "../../redux/slices/registrationAccountSlice";
import ReceiptFundraisingAccountControl from "./ReceiptFundraisingAccountControl";

const ConnectedReceiptFundraisingAccountControl = ({ controlId }) => {
    const receipt = useSelector(selectReceipt);
    const registrationAccount = useSelector(selectRegistrationAccount);

    const { isFundraisingParticipant = false } = registrationAccount;

    const {
        transaction: { registrations = [] },
    } = receipt;

    const { parentRegistration = 0 } = registrations[0];

    const isVisible = parentRegistration === 0 && isFundraisingParticipant;

    return (
        <ReceiptFundraisingAccountControl
            isVisible={isVisible}
            controlId={controlId}
        />
    );
};

ConnectedReceiptFundraisingAccountControl.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptFundraisingAccountControl;
